export default "__VITE_ASSET__fGsLqtvZ__"